__turbopack_context__.v({
  "container": "StrapSizeSelector-module-scss-module__vcq7xW__container",
  "dropdownLabel": "StrapSizeSelector-module-scss-module__vcq7xW__dropdownLabel",
  "rulerIcon": "StrapSizeSelector-module-scss-module__vcq7xW__rulerIcon",
  "selectorRow": "StrapSizeSelector-module-scss-module__vcq7xW__selectorRow",
  "sizeDropdown": "StrapSizeSelector-module-scss-module__vcq7xW__sizeDropdown",
  "sizeGuideButton": "StrapSizeSelector-module-scss-module__vcq7xW__sizeGuideButton",
  "wristSizeText": "StrapSizeSelector-module-scss-module__vcq7xW__wristSizeText",
});
